import { useState } from "react";
import type { BudgetSubcategory, BudgetItem } from "../types";

export function useSubcategoryDrawer() {
  const [openSubcategory, setOpenSubcategory] = useState<BudgetSubcategory | null>(null);
  const [selectedItem, setSelectedItem] = useState<BudgetItem | null>(null);
  const [isExpanded, setIsExpanded] = useState(false);

  function openDrawer(subcategory: BudgetSubcategory) {
    setOpenSubcategory(subcategory);
    setSelectedItem(null);
    setIsExpanded(false);
  }

  function selectItem(item: BudgetItem) {
    setSelectedItem(item);
    setIsExpanded(true);
  }

  function closeDetail() {
    setSelectedItem(null);
    setIsExpanded(false);
  }

  function closeDrawer() {
    setOpenSubcategory(null);
    setSelectedItem(null);
    setIsExpanded(false);
  }

  return {
    openSubcategory,
    selectedItem,
    isExpanded,
    openDrawer,
    selectItem,
    closeDetail,
    closeDrawer,
  };
}
